var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightNorth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.14288L5.47058 30.1715L15.5 24.9143L25.5294 30.1715L15.5 9.14288Z",
    stroke: "#161615",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 25.1429V9.14288L25.5294 30.1715L15.5 25.1429Z",
    fill: "#161615"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.853 4.18719C6.58023 5.76076 2.73529 10.6587 2.73529 16.4571C2.73529 19.5579 3.83478 22.4011 5.66414 24.6161L6.37979 23.0911C5.03103 21.2287 4.23529 18.9367 4.23529 16.4571C4.23529 11.4942 7.42326 7.28248 11.853 5.76263V4.18719ZM19.1471 5.76265C23.5767 7.2825 26.7647 11.4942 26.7647 16.4571C26.7647 18.9367 25.969 21.2287 24.6202 23.0911L25.3358 24.6161C27.1652 22.4011 28.2647 19.5579 28.2647 16.4571C28.2647 10.6587 24.4198 5.76079 19.1471 4.18721V5.76265ZM12.2851 28.8477L14.4778 27.7112C14.8145 27.7416 15.1555 27.7571 15.5 27.7571C15.8445 27.7571 16.1855 27.7416 16.5222 27.7112L18.7148 28.8477C17.6878 29.115 16.6104 29.2571 15.5 29.2571C14.3895 29.2571 13.3122 29.115 12.2851 28.8477Z",
    fill: "#161615"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1765 16.4571C29.1765 15.7886 29.1288 15.1312 29.0366 14.4883L31 16.4571L29.0366 18.426C29.1287 17.783 29.1765 17.1257 29.1765 16.4571ZM15.5 30.1714C16.1667 30.1714 16.8222 30.1236 17.4634 30.0311L15.5 32L13.5366 30.0311C14.1778 30.1236 14.8333 30.1714 15.5 30.1714ZM1.82353 16.4571C1.82353 17.1257 1.87124 17.783 1.96342 18.426L0 16.4571L1.96341 14.4883C1.87123 15.1312 1.82353 15.7886 1.82353 16.4571Z",
    fill: "#161615"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 1.44586V7.13336H16.5078L14.4961 3.5943V7.13336H13.125V1.44586H14.4961L16.5078 4.98492V1.44586H17.875Z",
    fill: "#161615"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightNorth);
export default __webpack_public_path__ + "static/media/light-north.d9f2afa4.svg";
export { ForwardRef as ReactComponent };